var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 6.5C7.75 4.15279 9.65279 2.25 12 2.25C14.3472 2.25 16.25 4.15279 16.25 6.5C16.25 8.84721 14.3472 10.75 12 10.75C9.65279 10.75 7.75 8.84721 7.75 6.5ZM9.36699 13.25H14.633C15.7251 13.25 16.5906 13.25 17.2883 13.307C18.0016 13.3653 18.6053 13.4869 19.1564 13.7677C20.0502 14.2231 20.7769 14.9498 21.2323 15.8436C21.5131 16.3947 21.6347 16.9984 21.693 17.7117C21.75 18.4094 21.75 19.2748 21.75 20.367V21C21.75 21.4142 21.4142 21.75 21 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21V20.367C2.24999 19.2749 2.24999 18.4094 2.30699 17.7117C2.36527 16.9984 2.48688 16.3947 2.76772 15.8436C3.22311 14.9498 3.94977 14.2231 4.84356 13.7677C5.39473 13.4869 5.99836 13.3653 6.71175 13.307C7.40936 13.25 8.27486 13.25 9.36699 13.25Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceIcon);
export default __webpack_public_path__ + "static/media/performanceIcon.1d3e6343b35455ebdba1939846834d96.svg";
export { ForwardRef as ReactComponent };